import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, assetUrl } from '../../lib/api';

export const NewsCards = ({ limit }) => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get('/posts').then((res) => setPosts(limit ? res.data.slice(0, limit) : res.data)).catch(() => {});
  }, [limit]);

  const formatDate = (d) => {
    try {
      return new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    } catch {
      return d;
    }
  };

  return (
    <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
      {posts.map((post) => (
        <Link
          key={post.slug}
          to={`/news-insights/${post.slug}`}
          data-testid="news-card"
          className="bg-white rounded-2xl shadow-[0_8px_20px_rgba(17,24,39,0.1)] overflow-hidden card-lift block"
        >
          <img src={assetUrl(post.image)} alt={post.title} className="w-full h-[220px] object-cover" loading="lazy" />
          <div className="p-6">
            <h3 className="text-[#2E8B57] font-extrabold text-lg leading-snug">{post.title}</h3>
            <p className="mt-2.5 text-xs text-black/60 font-medium">
              by {post.author} | {formatDate(post.date)} | {post.category}
            </p>
            {post.excerpt && <p className="mt-3 text-sm text-black/80 leading-6 line-clamp-4">{post.excerpt}</p>}
          </div>
        </Link>
      ))}
    </div>
  );
};
